const calculateBatteryLevel = (v, offset, model, deviceSerial, isLiDevice) => {
    if (!v) return '-';

    const modelLimits = {
        BL: {
            high: 4500,
            low: 3500
        },
        LT: {
            low: 3500,
            high: 4250
        }
    }
    var high = modelLimits[model]?.high || 4250
    var low = modelLimits[model]?.low || 3500
    var value = parseInt(v) + (parseInt(offset) || 0)

    if (isLiDevice && model === "LT") {
        high = 4100
        value = parseInt(v) + 250
        const cbp = calculateBatteryPercentage(value)
        // console.log(`Calculated cbp: ${cbp}, serial: ${deviceSerial} original value: ${v}, fixedValue: ${value}`)
        return `${cbp}%`
    }
    else {
        if (value <= low) {
            return '0%'
        } else if (value >= high) {
            return '100%'
        } else {
            return ((value - low) * 100 / (high - low)).toFixed(0) + '%'
        }
    }
}

/**
 * Normalizes battery percentage for UI and sorting
 * @param {import("../types/global").Device} device
 */
const getNormalizedBatteryPct = (device) => {
    // Plug-powered devices → special marker
    if (device.model === "EL" || device.model === "ELS") {
        return null; // means "no battery"
    }

    const raw = Number(device.batteryPct);

    if (Number.isNaN(raw)) return 0;

    // Clamp negative values to 0
    return Math.max(0, raw);
};

const getSortableBatteryValue = (device) => {
    // Plug-powered devices always last
    if (device.model === "EL" || device.model === "ELS") {
        return -1;
    }

    const raw = Number(device.batteryPct);

    if (Number.isNaN(raw)) return 0;

    // Clamp negatives to 0
    return Math.max(0, raw);
};

const getSignalStrengthForBars = (rawValue) => {
    if (rawValue === null || rawValue === undefined) {
        return { percentage: "0%", value: 0 };
    }

    const dBm = Number(rawValue);
    if (Number.isNaN(dBm)) {
        return { percentage: "0%", value: 0 };
    }

    let value;

    if (dBm >= -75) value = 5;                 // FULL
    else if (dBm >= -97) value = 3;            // THIRD
    else if (dBm >= -118) value = 2;           // SECOND
    else if (dBm >= -140) value = 1;           // FIRST
    else value = 0;                            // EMPTY
    return value
}

function calculateBatteryPercentage(currentBatteryLevel) {
    const thresholds = [3500, 3550, 3600, 3650, 3700, 3760, 3830, 3910, 4000, 4100];
    const percentages = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    for (let i = thresholds.length - 1; i >= 0; i--) {
        if (currentBatteryLevel >= thresholds[i]) {
            return percentages[i + 1];
        }
    }
    return 0;
}

const GALLON_TO_LITRE = 3.78541;


const toLitres = (value, locale) =>
    locale === "en" ? Math.round(value * GALLON_TO_LITRE) : value;

const fromLitres = (value, locale) =>
    locale === "en" ? Math.round(value / GALLON_TO_LITRE) : value;

export {
    calculateBatteryLevel,
    getNormalizedBatteryPct,
    getSortableBatteryValue,
    getSignalStrengthForBars,
    toLitres,
    fromLitres
}